import Money from '@mui/icons-material/AttachMoney';
import MoneyOff from '@mui/icons-material/MoneyOff';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { format } from 'date-fns/format';
import { useNavigate, useParams } from 'react-router-dom';
import ordersApi from '../../../api/order';
import LoadingSpinner from '../../../components/loadingSpinner/LoadingSpinner';
import OrderItemsList from '../../../components/orderSummary/OrderItemsList';
import OrderPricingList from '../../../components/orderSummary/OrderPricingList';
import useRequest from '../../../hooks/useRequest';
import { AdminHeader } from '../../Admin/components/AdminHeader';


export default function OrderDetailsPage() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { data: order, loading } = useRequest(() => ordersApi.getById(Number(orderId)), [orderId], isNaN(Number(orderId)));

  if (loading) {
    return <LoadingSpinner isLoading={loading} />;
  }

  if (!order || !order.items) {
    return (
      <Paper sx={{ p: 4, m: 2 }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            {!order ? ' Order not found' : 'Order contains no items'}
          </Typography>
          <Button variant="contained" onClick={() => navigate('/staff/pos')}>
            Back to POS
          </Button>
        </Box>
      </Paper>
    );
  }

  return (
    <>
      <AdminHeader
        title={`Order #${orderId}`}
        description="Order Details"
        showBackButton={true}
        onBackButtonClick={() => navigate('/staff/pos')}
      />
      <Stack sx={{ marginLeft: 4, marginRight: 4, marginTop: 2 }}>
        <Box
          sx={{
            mt: 3,
            backgroundColor: 'background.paper',
            borderRadius: 1,
            mb: 3,
          }}
        >
          <Stack direction="row" spacing={4}>
            <Box>
              <Typography
                sx={{ fontSize: '0.875rem', fontWeight: 600, mb: 1 }}
              >
                Customer Name
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1rem' }}>
                {order.customerName}
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{ fontSize: '0.875rem', fontWeight: 600, mb: 1 }}
              >
                Paid?
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1rem' }}>
                {order.isPaid ? <Money /> : <MoneyOff />}
              </Typography>
            </Box>
          </Stack>

          <Stack direction="row" spacing={4} sx={{ mt: 3 }}>
            <Box>
              <Typography
                sx={{ fontSize: '0.875rem', fontWeight: 600, mb: 1 }}
              >
                Created Time
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1rem' }}>
                {order.createdAt
                  ? format(new Date(order.createdAt), 'dd/MM/yy HH:mm a')
                  : '-'}
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{ fontSize: '0.875rem', fontWeight: 600, mb: 1 }}
              >
                Start Time
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1rem' }}>
                {order.startTime
                  ? format(new Date(order.startTime), 'dd/MM/yy HH:mm a')
                  : '-'}
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{ fontSize: '0.875rem', fontWeight: 600, mb: 1 }}
              >
                Finish Time
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1rem' }}>
                {order.finishTime
                  ? format(new Date(order.finishTime), 'dd/MM/yy HH:mm a')
                  : '-'}
              </Typography>
            </Box>
          </Stack>
        </Box>
        <OrderItemsList order={order} />
        <OrderPricingList order={order} />
      </Stack>
    </>
  );
}
